/* @ngInject */
function DateRangeDisplayController(DateTimeRangePickerService) {
  const vm = this;

  vm.isValidDateRange = () => DateTimeRangePickerService.isValidDateRange({ start: vm.start, end: vm.end });
}

export default {
  name: 'dateRangeDisplay',
  template:
    `<label>Date Range:</label>
    <p ng-if="$ctrl.isValidDateRange()"
        ng-style="::($ctrl.horizontal && {'display': 'inline'})" >
        {{$ctrl.start | date:'short'}} - {{$ctrl.end | date:'short'}}</p>
    <p ng-if="!$ctrl.isValidDateRange()" class="alert-danger">Invalid dates selected</p>`,
  controller: DateRangeDisplayController,
  bindings: {
    start: '<',
    end: '<',
    horizontal: '<?',
  }
};
